const sections = document.querySelectorAll('.js-zoom-in');

function updateZoom() {
   sections.forEach((section) => {
      const inner = section.querySelector('.js-zoom-in__inner');
      if (!inner) return;

      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const progress = Math.max(
         0,
         Math.min(
            1,
            (windowHeight - rect.top) / (windowHeight + rect.height)
         )
      );

      const scale = 1 + progress * 0.20;

      inner.style.transform = `scale(${scale})`;
   });
}

window.addEventListener('scroll', updateZoom, { passive: true });
window.addEventListener('resize', updateZoom);

updateZoom();